<template>
  <div class="div_btn_inline">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :small="buttonSizeSmall"
          fab
          v-if="idAccion == 1 && icono"
          color="success" 
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon :small="buttonSizeSmall">
            mdi-plus
          </v-icon>
        </v-btn>
        <v-btn
          :small="buttonSizeSmall"
          v-if="idAccion == 1 && !icono"
          color="success" 
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon :small="buttonSizeSmall">
            mdi-plus
          </v-icon>
          Agregar pregunta
        </v-btn>
      </template>
      <span>Agregar pregunta</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :small="buttonSizeSmall"
          v-if="idAccion == 2 && icono"
          color="info" 
          v-bind="attrs"
          v-on="on"
          class="mx-2"
          @click.stop="dialog = true"
        >
          <v-icon :small="buttonSizeSmall">
            mdi-pencil
          </v-icon>
          Editar
        </v-btn>
        <v-btn
          :small="buttonSizeSmall"
          v-if="idAccion == 2 && !icono"
          color="info" 
          v-bind="attrs"
          v-on="on"
          class="mx-2"
          @click.stop="dialog = true"
        >
          <v-icon :small="buttonSizeSmall">
            mdi-pencil
          </v-icon>
          Editar pregunta
        </v-btn>
      </template>
      <span>Editar pregunta</span>
    </v-tooltip>

    <v-dialog
      :name="'dialog_form_pregunta_' + idPregunta"
      :key="'dialog_form_pregunta_' + idPregunta"
      v-model="dialog"
      width="700"
      max-width="700"
      scrollable
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="text-h5 blue darken-4 lighten-2">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="h5" style="color:white!important;">
                <v-icon color="white">{{ idAccion == 1 ? 'mdi-plus' : 'mdi-pencil' }}</v-icon>
                {{ idAccion == 1 ? 'Agregar Pregunta' : 'Editar Pregunta' }}
              </div>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-form 
            class="mt-5 my-5"
            ref="form" 
            v-model="valid" 
            :lazy-validation="lazy"
          >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="nombrePregunta"
                  :loading="loading"
                  label="Nombre de la Pregunta *"
                  :rules="[(v) => !!v || 'Campo obligatorio']"
                  outlined
                  dense
                  required
                ></v-text-field>  
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <select-cat-tipo-pregunta :id-cat-tipo-pregunta-prop="idCatTipoPregunta" :fn-change="setIdTipoPregunta" :requerido="true"></select-cat-tipo-pregunta>
              </v-col>
            </v-row>

            <div v-if="idCatTipoPregunta == 2">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="valorMinimo"
                    :loading="loading"
                    label="Valor Mínimo *"
                    :rules="[(v) => v != '' || 'Campo obligatorio']"
                    type="number"
                    outlined
                    dense
                    required
                  ></v-text-field>  
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="valorMaximo"
                    :loading="loading"
                    label="Valor Máximo *"
                    :rules="[(v) => !!v || 'Campo obligatorio']"
                    type="number"
                    outlined
                    dense
                    required
                  ></v-text-field>  
                </v-col>
              </v-row>

              <v-row class="mb-3">
                <v-col cols="12" md="6">
                  <v-switch 
                    v-model="promediable" 
                    class="mx-2" 
                    label="Pregunta promediable" 
                    required  
                    style="justify-content: center; display: grid;  margin-top:5px;"
                    hide-details
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="6">
                  <v-switch 
                    v-model="selectorNumerico" 
                    class="mx-2" 
                    label="¿Es selector numérico?" 
                    required  
                    style="justify-content: center; display: grid;  margin-top:5px;"
                    hide-details
                  ></v-switch>
                </v-col>
              </v-row>

              <v-row v-if="selectorNumerico">
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="etiquetaInicial"
                    :loading="loading"
                    label="Etiqueta inicial"
                    outlined
                    dense
                  ></v-text-field>  
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="etiquetaFinal"
                    :loading="loading"
                    label="Etiqueta final"
                    outlined
                    dense
                  ></v-text-field>  
                </v-col>
              </v-row>
            </div>

            <div v-if="idCatTipoPregunta == 3">
<v-row>
               <v-col cols="12" md="5">
                  <v-switch 
                    v-model="promediable" 
                    class="mx-2" 
                    label="Pregunta promediable" 
                    required  
                    style="justify-content: center; display: grid;  margin-top:5px;"
                    hide-details
                  ></v-switch>
                </v-col>   
               <v-col cols="12" md="7">
                <v-switch 
                  v-model="horizantal" 
                  class="mx-2" 
                  label="Mostrar las respuestas horizontalmente" 
                  required  
                  style="justify-content: center; display: grid;  margin-top:5px;"
                  hide-details
                ></v-switch>
                </v-col>          
</v-row>
            </div>
            <div v-if="idCatTipoPregunta == 4">

              <v-col cols="12" class="mb-2">
                <v-switch 
                  v-model="horizantal" 
                  class="mx-2" 
                  label="Mostrar las respuestas horizontalmente" 
                  required  
                  style="justify-content: center; display: grid;  margin-top:5px;"
                  hide-details
                ></v-switch>
              </v-col>
                          
            </div>
            
            <div v-if="idCatTipoPregunta == 6">
              <v-row>

                <v-col cols="12" class="mb-2">
                  <v-switch 
                    v-model="parametroVisible" 
                    class="mx-2" 
                    label="Parámetro visible" 
                    required  
                    style="justify-content: center; display: grid;  margin-top:5px;"
                    hide-details
                  ></v-switch>
                </v-col>   

                <v-col cols="12">
                  <v-select
                    v-model="idCatParametro"
                    :items="lstCatParametro"
                    item-text="nombreParametro"
                    item-value="idCatParametro"
                    label="Tipo de parámetro *"
                    :loading="loadingCatParametro"
                    :rules="[(v) => !!v || 'Campo obligatorio']"
                    outlined
                    dense
                    required
                  >
                  </v-select>
                </v-col>
              </v-row>   
            </div>

            <v-row>
              <v-col :cols="idPreguntaDependiente == null ? 12 : 6">
                <v-select
                  v-model="idPreguntaDependiente"
                  :items="lstPreguntasComp"
                  item-text="nombrePregunta"
                  item-value="idPregunta"
                  label="¿Es dependiente de una pregunta?"
                  outlined
                  dense                  
                >                  
                </v-select>
              </v-col>

              <v-col v-if="idPreguntaDependiente != null" cols="6">
                <v-select
                  v-model="idCatRespuestaDependiente"
                  :items="lstRespuestas"
                  item-text="respuesta"
                  item-value="idCatRespuesta"
                  label="Seleccione la respuesta que depende esta pregunta"
                  outlined
                  dense                  
                >                  
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6" offset-md="3">
                <v-file-input
                  v-model="imgPregunta"
                  :loading="loadingImg"
                  label="Imagen"
                  outlined
                  dense
                  accept="image/*"
                ></v-file-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-switch 
                  v-model="habilitado" 
                  class="mx-2" 
                  label="Habilitada" 
                  required  
                  style="justify-content: center; display: grid;  margin-top:5px;"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="12" md="6">
                <v-switch 
                  v-model="requerida" 
                  class="mx-2" 
                  label="Requerida" 
                  required  
                  style="justify-content: center; display: grid;  margin-top:5px;"
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-center">
                <small>* Campo obligatorio</small>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn
                  class="mx-2"
                  color="default"
                  :loading="loadingSave"
                  @click="dialog = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  class="mx-2"
                  color="success"
                  :disabled="!valid"
                  :loading="loadingSave"
                  @click="guardar"
                >
                <v-icon class="mr-2">mdi-floppy</v-icon>
                  guardar Pregunta
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      :name="'snackbar_dialog_form_pregunta_' + idPregunta"
      :key="'snackbar_dialog_form_pregunta_' + idPregunta"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { postPregunta, putPregunta, getCatParametro, getImagenPreguntaByIdPregunta } from "@/api";

export default {
  name: "DialogFormPregunta",
  components: {
    SelectCatTipoPregunta: () =>
      import("../comunes/SelectCatTipoPregunta"),
  },
  props: {
    idAccion: {
      type: Number,
      required: true
    },
    idEncuestaProp: {
      type: Number,
      required: true
    },
    idSeccionProp: {
      type: Number,
      required: true
    },
    objPregunta: {
      type: Object,
      default: function () {
        return {
          idPregunta: 0,
          idCatTipoPregunta: null,
          idSeccion: 0,
          nombrePregunta: '',
          valorMinimo: null,
          valorMaximo: null,
          habilitado: true,
          promediable: false,
          horizantal: false,
          selectorNumerico: false,
          etiquetaInicial: '',
          etiquetaFinal: '',
          orden: 0,
          grupo: '',
          requerida: true,
          idCatRespuestaDependiente: null,
          parametroVisible: false,
          idPreguntaDependiente: null,
          idCatParametro: null,
          tieneImagen: null
        }
      }
    },
    fnOnSave: {
      type: Function,
      default: () => {}
    },
    buttonSizeSmall: {
      type: Boolean,
      default: false
    },
    icono:  {
      type: Boolean, 
      default: false
    },
    lstGrupos: {
      type: Array,
      default: function () {
        return []
      }
    },
    lstPreguntas: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      loadingSave: false,

      valid: false,
      lazy: false,

      flagInitForm: 1,
      idAccionForm: 1,

      searchGrupo: null,

      loadingCatParametro: false,
      lstCatParametro: [],

      idPregunta: 0,
      idCatTipoPregunta: null,
      idSeccion: 0,
      nombrePregunta: '',
      valorMinimo: null,
      valorMaximo: null,
      habilitado: true,
      promediable: false,
      horizantal: false,
      selectorNumerico: false,
      etiquetaInicial: '',
      etiquetaFinal: '',
      orden: 0,
      grupo: '',
      requerida: true,
      idCatRespuestaDependiente: null,
      parametroVisible: false,
      idPreguntaDependiente: null,
      idCatParametro: null,
      tieneImagen: null,
      imgPregunta: null,
      loadingImg: false,

      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",

      banLimpiarDatos: 0,
    };
  },
  computed: {
    lstPreguntasComp: function () {

      var newLst = [];
      newLst.push({idPregunta: null, nombrePregunta: 'No depende de ninguna pregunta'});
      Array.prototype.push.apply(newLst, this.lstPreguntas.filter(n=>n.idPregunta != this.idPregunta));
      return newLst;
    },
    lstRespuestas: function () {
      if(this.idPreguntaDependiente == null){
        return [];
      }
      else{
        var objPreg = this.lstPreguntas.filter(n=>n.idPregunta == this.idPreguntaDependiente)[0];

        if(objPreg == undefined){
          return [];
        }
        else{
          return objPreg.eiCatRespuesta;
        }
      }
    }
  },
  watch:{
    dialog: {
      handler (newValue, oldValue) {
        if(this.$refs.form != undefined && newValue == true){
          this.$refs.form.resetValidation();
        }
        if(newValue == true){
          this.idPregunta = this.objPregunta.idPregunta;
          this.idCatTipoPregunta = this.objPregunta.idCatTipoPregunta;
          this.idSeccion = this.idAccion == 1 ? this.idSeccionProp : this.objPregunta.idSeccion;
          this.nombrePregunta = this.objPregunta.nombrePregunta;
          this.valorMinimo = this.objPregunta.valorMinimo;
          this.valorMaximo = this.objPregunta.valorMaximo;
          this.habilitado = this.objPregunta.habilitado;
          this.promediable = this.objPregunta.promediable;
          this.horizantal = this.objPregunta.horizantal;
          this.selectorNumerico = this.objPregunta.selectorNumerico;
          this.etiquetaInicial = this.objPregunta.etiquetaInicial;
          this.etiquetaFinal = this.objPregunta.etiquetaFinal;
          this.orden = this.objPregunta.orden;
          this.grupo = this.objPregunta.grupo;
          this.requerida = this.objPregunta.requerida;
          this.idCatRespuestaDependiente = this.objPregunta.idCatRespuestaDependiente;
          this.parametroVisible = this.objPregunta.parametroVisible;
          this.idPreguntaDependiente = this.objPregunta.idPreguntaDependiente;
          this.idCatParametro = this.objPregunta.idCatParametro;
          this.tieneImagen = this.objPregunta.tieneImagen;
        }
        else{
          this.idPregunta = 0;
          this.idCatTipoPregunta = null;
          this.idSeccion = 0;
          this.nombrePregunta = '';
          this.valorMinimo = null;
          this.valorMaximo = null;
          this.habilitado = true;
          this.promediable = false;
          this.horizantal = false;
          this.selectorNumerico = false;
          this.etiquetaInicial = '';
          this.etiquetaFinal = '';
          this.orden = 0;
          this.grupo = '';
          this.requerida = true;
          this.idCatRespuestaDependiente = null;
          this.parametroVisible = false;
          this.idPreguntaDependiente = null;
          this.idCatParametro = null;
          this.tieneImagen = null;
        }

        if(this.tieneImagen == true){
          this.obtenerImagenPreguntaByIdPregunta();
        }
			},
    },
    idCatTipoPregunta: {
      handler (newValue, oldValue) {
        if(this.objPregunta.idCatTipoPregunta == null && this.objPregunta.idCatTipoPregunta != newValue)
        {
          this.valorMinimo = null;
          this.valorMaximo = null;
          this.promediable = false;
          this.horizantal = false;
          this.selectorNumerico = false;
          this.etiquetaInicial = '';
          this.etiquetaFinal = '';
          this.grupo = '';
          this.parametroVisible = false;
          this.idCatParametro = null;
        }
			},
    }
  },
  beforeMount(){
  },
  mounted() {
    this.cargarCatParametro();
  },
  methods: {
    async guardar(){
      var self = this;

      if (self.$refs.form.validate()) {

        self.loadingSave = true;
        self.snackbar = false;
        self.snackbarTexto = "";
        self.snackbarColor = "";
            
        try {
          let response;

          var obj = {
            idPregunta: this.idPregunta,
            idCatTipoPregunta: this.idCatTipoPregunta,
            idSeccion: this.idSeccion,
            nombrePregunta: this.nombrePregunta,
            valorMinimo: this.valorMinimo,
            valorMaximo: this.valorMaximo,
            habilitado: this.habilitado,
            promediable: this.promediable,
            horizantal: this.horizantal,
            selectorNumerico: this.selectorNumerico,
            etiquetaInicial: this.etiquetaInicial,
            etiquetaFinal: this.etiquetaFinal,
            orden: this.orden,
            grupo: this.grupo,
            requerida: this.requerida,
            idCatRespuestaDependiente: this.idCatRespuestaDependiente,
            parametroVisible: this.parametroVisible,
            idPreguntaDependiente: this.idPreguntaDependiente,
            idCatParametro: this.idCatParametro
          }
     
          if(obj.idPregunta == 0){
            
            response = await postPregunta(obj, this.imgPregunta);
          }
          else{
            response = await putPregunta(obj, this.imgPregunta);
          }

          if (response.status === 200) {
            if (response.data.flag === true) {
              if (response.data.message === "Guardado correcto") {
                self.snackbarTexto = "Pregunta guardada con éxito";
                self.snackbarColor = "success";
                self.snackbar = true;

                self.fnOnSave();

                self.dialog = false;
              }
            } else {
              self.snackbarTexto = "DialogFormPregunta: " + response.data.message;
              self.snackbarColor = "error";
              self.snackbar = true;
            }
          } else {
            self.snackbarTexto = "DialogFormPregunta: Error de red";
            self.snackbarColor = "error";
            self.snackbar = true;
          }
          self.loadingSave = false;
        } catch (e) {
          self.loadingSave = false;
          self.snackbarTexto = "DialogFormPregunta: " + e;
          self.snackbarColor = "error";
          self.snackbar = true;
        }
      }
    },
    async cargarCatParametro () {
      var self = this;

      self.loadingCatParametro = true;
      self.lstCatParametro = [];
      self.snackbar = false;
      self.snackbarColor = '';
      self.snackbarTexto = '';

      try {
        let response = await getCatParametro();

        if (response.status === 200) {        
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              if(response.data.data.length > 0){
                self.lstCatParametro.push({idCatParametro: null, nombreParametro: "Seleccione una opción"});
                Array.prototype.push.apply(self.lstCatParametro, response.data.data);
              }
            }
            else{
              self.snackbarColor = 'error';
              self.snackbarTexto = response.data.message;
              self.snackbar = true;
            }
          } else {
            self.snackbarColor = 'error';
            self.snackbarTexto = response.data.message;
            self.snackbar = true;
          } 
        } else {
          self.snackbarColor = 'error';
          self.snackbarTexto = 'Error de red';
          self.snackbar = false;
        }
        self.loadingCatParametro = false;
      } catch (e) {        
        self.snackbarColor = 'error';
        self.snackbarTexto = e;
        self.snackbar = true;
        self.loadingCatParametro = false;
      }
    },
    setIdTipoPregunta(_idCatTipoPregunta){
      this.idCatTipoPregunta = _idCatTipoPregunta;
    },
    async obtenerImagenPreguntaByIdPregunta () {

      var self = this;
      self.loadingImg = true;

      self.snackbarTexto = "";
      self.snackbarColor = "";
      self.snackbar = false;

      try {
        let response = await getImagenPreguntaByIdPregunta(self.idPregunta);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              this.imgPregunta = new File([response.data.data.docto], response.data.data.nombreArchivo, {
                                                type: response.data.data.contenttype,
                                              });
            }
          } else {
            self.snackbarTexto = "DialogFormPregunta: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
          }
        } else {
          self.error = "Error de red";
          self.snackbarTexto = "DialogFormPregunta: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
        }
        self.loadingImg = false;
      } catch (e) {
        self.loadingImg = false;
        self.error = e;
        self.snackbarTexto = "DialogFormPregunta: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
  },  
};
</script>